export const footerLinks = [
  {
    id: 1,
    text: 'about us',
    path: '/',
  },
  {
    id: 2,
    text: 'contact us',
    path: '/',
  },
  {
    id: 3,
    text: 'track order',
    path: '/',
  },
  {
    id: 4,
    text: 'terms & conditions',
    path: '/',
  },
  {
    id: 5,
    text: 'privacy policy',
    path: '/',
  },
  {
    id: 6,
    text: 'sell with us',
    path: '/',
  },
  {
    id: 7,
    text: 'shopping and returns',
    path: '/',
  },
];

export const footerSocialLinks = [
  {
    id: 1,
    icon: '/images/facebook.svg',
    path: 'https://www.linkedin.com/in/ibrahiimkamal/detail/recent-activity/shares/',
    text: '/YESHTERY',
  },

  {
    id: 2,
    icon: '/images/linkedin.svg',
    path: 'https://www.linkedin.com/in/ibrahiimkamal/detail/recent-activity/shares/',
    text: '/YESHTERY',
  },

  {
    id: 3,
    icon: '/images/insta.svg',
    path: 'https://www.linkedin.com/in/ibrahiimkamal/detail/recent-activity/shares/',
    text: '/YESHTERY',
  },

  {
    id: 4,
    icon: '/images/twitter.svg',
    path: 'https://www.linkedin.com/in/ibrahiimkamal/detail/recent-activity/shares/',
    text: '/YESHTERY',
  },
];
